import React, { useState, useMemo } from 'react';
import classnames from 'classnames';
import Select from 'react-select';

import css from './MultiSelect.css';

export const objectToOptions = obj =>
	Object.keys(obj).map(i => ({
		value: i,
		label: obj[i]
	}));

export const arrayToOptions = (arr, format) =>
	arr.map(i => ({
		value: i,
		label: format ? format(i) : i
	}));

export const valueToOption = (v, options) => (v.value ? v : options.find(o => o.value == v));

export const MultiSelect = ({
	name,
	value,
	label,
	onChange = () => {},
	options,
	className,
	isSearchable = false,
	hideOnPrint,
	wideLabels
}) => {
	const plus = useMemo(() => ({ value: 'add', label: '+' }), []);
	const _options = useMemo(() => options.concat(plus), [options]);
	const _value = useMemo(() => [].concat(value, plus), [value]);

	const onSelectAll = () => onChange(options);
	const onDeselectAll = () => onChange([]);

	const allSelected = Array.isArray(value) && value.length == options.length;
	const noneSelected = !value || value.length == 0;
	const handleChange = (selectedOptions, a, b) => {
		selectedOptions = selectedOptions != null ? selectedOptions : [];
		_options.length == selectedOptions.length ? setIsOpen(false) : setIsOpen(true);

		onChange(selectedOptions.filter(o => o != plus), a, b);
	};
	const [isOpen, setIsOpen] = useState();

	const handleFocus = () => setIsOpen(true);
	const handleBlur = e => setIsOpen(false);

	return (
		<div
			className={classnames(className, 'select__wrapper', {
				'select__wrapper--wide-labels': wideLabels,
				'select__wrapper--all-selected': allSelected
			})}>
			{label && <label>{label}</label>}
			<Select
				value={[].concat(_value).map(i => valueToOption(i, _options))}
				onChange={handleChange}
				onFocus={handleFocus}
				onBlur={handleBlur}
				isMulti
				menuIsOpen={isOpen}
				isSearchable={isSearchable}
				isSearchable={false}
				isClearable={false}
				name="colors"
				options={_options}
				classNamePrefix="select"
			/>
			<div className="select__extra-controls">
				{!allSelected && (
					<a className="select__select-all" onClick={onSelectAll}>
						select all
					</a>
				)}
				{!noneSelected && !allSelected && ' | '}
				{!noneSelected && (
					<a className="select__deselect-all" onClick={onDeselectAll}>
						clear
					</a>
				)}
			</div>
			{hideOnPrint ? null : (
				<div className={'select__print-label'}>
					<strong>{label}: </strong>
					{value.map((v, i) => (
						<span key={i}>
							{valueToOption(v).label}
							{i == value.length - 1 ? '.' : ', '}{' '}
						</span>
					))}
				</div>
			)}
		</div>
	);
};
export default React.memo(MultiSelect);
